import type { CSSProperties } from 'react';
import { COLORS } from '../../shared/types';

export function LanternMark({ className = '' }: { className?: string }) {
  return (
    <svg className={className} width="32" height="39" viewBox="0 0 32 39" fill="none" aria-hidden="true">
      <path d="M10 10V7a6 6 0 0 1 12 0v3" stroke="currentColor" strokeWidth="2.3" />
      <path d="M7 12h18l2 19-5 5H10l-5-5 2-19Z" fill="#EAC264" stroke="currentColor" strokeWidth="2.3" strokeLinejoin="round" />
      <path d="M5 12h22M8 31h16M10 36h12" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" />
      <path d="M16 16c0 5-4 5-4 9a4 4 0 0 0 8 0c0-3-2-5-4-9Z" fill="#FFF6D9" />
      <path d="M11 13 9 30m12-17 2 17" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}

export function Brand({ small = false }: { small?: boolean }) {
  return (
    <span className={`brand${small ? ' brand-small' : ''}`} aria-label="Hearthhop">
      <LanternMark />
      <span aria-hidden="true">HEARTHHOP<span className="brand-period">.</span></span>
    </span>
  );
}

export function CourierAvatar({ color, number, className = '' }: {
  color: number;
  number?: number;
  className?: string;
}) {
  const fill = COLORS[color % COLORS.length] ?? COLORS[0];
  return (
    <span className={`courier-avatar ${className}`} style={{ '--courier-color': fill } as CSSProperties} aria-hidden="true">
      <svg viewBox="0 0 64 72" fill="none">
        <ellipse cx="32" cy="66" rx="21" ry="4" fill="currentColor" opacity=".08" />
        <path d="M24 15v-4a8 8 0 0 1 16 0v4" stroke="#25493D" strokeWidth="3.5" strokeLinecap="round" />
        <path d="m15 34-5 8m39-8 5 8" stroke="#25493D" strokeWidth="4" strokeLinecap="round" />
        <path d="M24 54v9h-6m22-9v9h6" stroke="#25493D" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17 20h30l3 30a7 7 0 0 1-7 8H21a7 7 0 0 1-7-8l3-30Z" fill={fill} stroke="#25493D" strokeWidth="2.5" />
        <path d="M19 22h26l1 8H18l1-8Z" fill="#FFF9DF" fillOpacity=".45" />
        <path d="M15 20h34" stroke="#25493D" strokeWidth="4" strokeLinecap="round" />
        <path d="M25 38v4m14-4v4" stroke="#25493D" strokeWidth="3.5" strokeLinecap="round" />
        <path d="M29 47q3 3 6 0" stroke="#25493D" strokeWidth="2" strokeLinecap="round" />
        <circle cx="21" cy="45" r="3" fill="#CE7060" opacity=".35" />
        <circle cx="43" cy="45" r="3" fill="#CE7060" opacity=".35" />
      </svg>
      {number !== undefined && <span className="courier-number">{number}</span>}
    </span>
  );
}

export function Campfire({ celebration = false }: { celebration?: boolean }) {
  return (
    <svg className={`campfire-art${celebration ? ' campfire-celebration' : ''}`} viewBox="0 0 360 160" fill="none" aria-hidden="true">
      <ellipse cx="180" cy="126" rx="150" ry="28" fill="#D9DEC5" fillOpacity=".42" />
      <ellipse cx="180" cy="120" rx="89" ry="24" stroke="#A1AD8B" strokeDasharray="3 8" opacity=".55" />
      <ellipse cx="180" cy="90" rx="55" ry="55" fill="#F0CD72" opacity=".16" />
      <ellipse cx="180" cy="95" rx="37" ry="37" fill="#F0CD72" opacity=".2" />
      <path d="m153 126 56-16m-56 0 56 16" stroke="#765E43" strokeWidth="12" strokeLinecap="round" />
      <path d="m153 126 56-16m-56 0 56 16" stroke="#B78F59" strokeWidth="6" strokeLinecap="round" />
      <path className="campfire-flame" d="M180 40c5 22 21 26 18 43 9-3 11-11 11-11 15 28-3 44-28 44-24 0-44-19-24-44 0 12 6 11 6 11-3-19 15-22 17-43Z" fill="#D78547" />
      <path className="campfire-flame-inner" d="M180 67c3 16 13 20 12 27 7 13-2 21-12 21-16 0-22-13-14-22 0 6 4 7 4 7-2-14 10-18 10-33Z" fill="#F5CF6F" />
      <path d="M180 92c7 9 8 13 5 18-3 5-12 4-13-2-1-6 6-8 8-16Z" fill="#FFF1BF" />
      <g className="campfire-sparks" fill="#DFAE4F">
        <path d="m150 53 2-7 2 7-2 7-2-7Zm53-24 2-7 2 7-2 7-2-7Z" />
        <circle cx="167" cy="30" r="2" /><circle cx="222" cy="60" r="2" />
        <circle cx="124" cy="79" r="2.5" /><circle cx="249" cy="89" r="2" />
      </g>
      <g stroke="#73896C" strokeWidth="2" strokeLinecap="round">
        <path d="M68 117v-13m0 8-5-5m5 2 5-5m217 20v-15m0 8-5-4m5 0 5-5M93 135l-4-7m4 7 5-7m164 7-4-7m4 7 5-7" />
      </g>
      <g fill="#E8C575"><circle cx="57" cy="109" r="3" /><circle cx="303" cy="120" r="3" /></g>
    </svg>
  );
}
